import script from "./tool-collection.vue?vue&type=script&setup=true&lang=js"
export * from "./tool-collection.vue?vue&type=script&setup=true&lang=js"

import "./tool-collection.vue?vue&type=style&index=0&id=0fe9485c&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe9485c"]])

export default __exports__